// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { serializeCookie } from '../../utils/cookie';
export const appendSetCookieHeadersToNextApiResponse = (response, cookies, setCookieOptions) => {
    for (const { name, value } of cookies) {
        response.appendHeader('Set-Cookie', serializeCookie(name, value, setCookieOptions));
    }
};
